import React from "react";
import visa from "../Assets/images/visa.png"
import master from "../Assets/images/master.png"
import oneLink from "../Assets/images/1link.png"
import jazzCash from "../Assets/images/jc-logo.png"
import easyPaisa from "../Assets/images/easypaisa-logo.png"

const SectionFive = () => {

    return (
        <div className='mx-auto  lg:w-maxWidth w-full flex flex-col gap-12 mt-0 lg:mt-36 mb-10 lg:p-0  p-4'>
            <div className='w-full flex items-center justify-center flex-col gap-2'>
                <h2 className="font-roboto  font-light text-primary text-center leading-10 lg:leading-0 text-2xl lg:text-4xl  ">Multiple <b className="font-bold">Payment Collection Channels</b></h2>
                <p className=" font-roboto text-secondary text-lg">PayPro empowers you to enable your customers to make their payments with their debit/credit cards, bank and wallet transfers</p>
            </div>
            <div className='w-full flex justify-between items-center '>
                 <img className='w-1/6' src={visa} alt={visa} />
                 <img className='w-1/6' src={master} alt={master} />
                 <img className='w-1/6' src={oneLink} alt={oneLink} />
                 <img className='w-1/6' src={jazzCash} alt={jazzCash} />
                 <img className='w-1/6' src={easyPaisa} alt={easyPaisa} />
            </div>
        </div>
    )
}

export default  SectionFive